const ROUTES = {
  // GAME URLS
  APP_URL_HOME: '/game',
  APP_URL_LOGIN: '/login',
  APP_URL_USER_HOME: '/user-home',
  APP_URL_GAME_SELECTION: '/game-selection',
  APP_URL_LOBBY: '/lobby/:joinCode?',
  APP_URL_FACILITATORS: '/facilitators',
  BALANCE_SHEET: '/balance-sheet',
  BEGINNING_OF_THE_YEAR: '/beginning-of-the-year',
  CALCULATIONS: '/calculations',
  CASH_FLOW: '/cash-flow',
  COST_ACCOUNTING: '/cost-accounting',
  CONTRIBUTION_MARGIN: '/contribution-margin',
  DECISION_AIDS: '/decision-aids',
  MARKET_ROUND: '/market-round',
  END_OF_THE_YEAR: '/end-of-the-year',
  FINANCES: '/finances',
  INCOME_STATEMENT: '/income-statement',
  KPI_ANALYSIS: '/kpi-analysis',
  LIQUIDITY_CALCULATION: '/liquidity-calculation',
  MARKET_ANALYSIS: '/market-analysis',
  REPORTS: '/reports',
  MY_ORDERS: '/my-orders',
  PRODUCTION_PLAN: '/production-plan',
  QUARTERLY_ACTIONS: '/quarterly-actions',
  SETTINGS: '/settings',
  GAME_INFORMATION: '/game-information',
  // Strategy
  STRATEGY: '/strategy',
  FORECASTS: '/forecasts',
  // Investments
  BUY_MACHINE: '/buy-machine',
  SELL_MACHINE: '/sell-machine',
  BUY_PLANT: '/buy-plant',
  RENT_PLANT: '/rent-plant',
  SELL_PLANT: '/sell-plant',
  PRODUCT_CHANGEOVER: '/product-changeover',
  // Graphics
  GRAPHICS: '/graphics',
  WAITING_JOIN_GRAPHICS: '/waiting-join-graphics',
  MARKET_POSITION: '/market-position',
  COMPETITION_ANALYSIS: '/competition-analysis',
  MARKETING: '/marketing',
  PRODUCT_QUALITY_INDEX: '/product-quality-index',
  TRAINING_INDEX: '/training-index',
  QUANTITY_SALES: '/quantity-sales',
  MARKET_SHARE: '/market-share',
  ANNUAL_RESULT: '/annual-result',
  CHANGE_IN_PROFIT: '/change-in-profit',
  RETURN_ON_EQUITY: '/return-on-equity',
  EQUITY_CAPITAL: '/equity-capital',
  BORROWED_CAPITAL_RATIO: '/borrowed-capital-ratio',
  DIVIDENDS: '/dividends',
  SHARE_PRICE: '/share-price',
  AVG_RESULT: '/avg-result',
  CUMULATIVE_SALES: '/cumulative-sales',
  CUMULATIVE_SALES_PRODUCTS: '/cumulative-sales-products',
  CUMULATIVE_SALES_MARKETS: '/cumulative-sales-markets',
  CURRENT_GRAPHICS: '/current-graphics',
  // Dashboard
  DASHBOARD: '/dashboard',
  SALES: '/sales',
  PRODUCTS: '/products',
  MARKETS: '/markets',
  FINANCIALS: '/financials',
  COMPETITORS: '/competitors',
  // Participants form
  PARTICIPANTS: '/participants',
  INTRO: '/intro',
  BUSINESS_PLAN_AND_STRATEGY: '/business-plan-and-strategy',
  INVESTMENT_CALCULATION: '/investment-calculation',
  STRATEGIC_EVALUATION: '/strategic-evaluation',
  CONCLUSION: '/conclusion'
}

/** Build lobby URL with game join code (e.g. /lobby/ABC01245) */
export const getLobbyUrl = (joinCode) =>
  joinCode ? `/lobby/${encodeURIComponent(joinCode)}` : '/lobby'

export const PARTICIPANTS_FORM_ROUTES = [
  `${ROUTES.PARTICIPANTS}${ROUTES.INTRO}`,
  `${ROUTES.PARTICIPANTS}${ROUTES.BUSINESS_PLAN_AND_STRATEGY}`,
  `${ROUTES.PARTICIPANTS}${ROUTES.INVESTMENT_CALCULATION}`,
  `${ROUTES.PARTICIPANTS}${ROUTES.STRATEGIC_EVALUATION}`,
  `${ROUTES.PARTICIPANTS}${ROUTES.CONCLUSION}`
]

export const DASHBOARD_ROUTES = [
  `${ROUTES.DASHBOARD}${ROUTES.SALES}`,
  `${ROUTES.DASHBOARD}${ROUTES.MY_ORDERS}`,
  `${ROUTES.DASHBOARD}${ROUTES.PRODUCTS}`,
  `${ROUTES.DASHBOARD}${ROUTES.MARKETS}`,
  `${ROUTES.DASHBOARD}${ROUTES.FINANCIALS}`,
  `${ROUTES.DASHBOARD}${ROUTES.COMPETITORS}`
]

export default ROUTES
